import React, { useState, useRef, useEffect } from 'react'
import Slider from 'react-slick'
import SbEditable from 'storyblok-react'
import Headline from '../atoms/Headline'
import Image from '../atoms/Image'
import Richtext from '../atoms/Richtext'

// Workaround: Verhindert falsche Start-Höhe des Contents, weil Bild zu lange zum Laden braucht. => Refactoring

const GalleryBlock = ({ block }) => {
  const refChild = useRef()
  const [arrowHeightState, setArrowHeightState] = useState(0)
  const [dotsHeightState, setDotsHeightState] = useState(0)
  useEffect(() => {
    setTimeout(() => {
      setArrowHeightState(refChild.current.offsetHeight - 48)
      setDotsHeightState(refChild.current.offsetHeight - 64)
    }, 1000)
  })

  function NextArrow(props) {
    const { className, onClick, arrowHeightState } = props
    return (
      <span
        className={className}
        style={{ top: arrowHeightState, bottom: 'inherit' }}
        onClick={onClick}
      >
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick, arrowHeightState } = props
    return (
      <span
        className={className}
        style={{ top: arrowHeightState, bottom: 'inherit' }}
        onClick={onClick}
      >
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    infinite: false,
    prevArrow: (
      <PrevArrow className="slick-prev" arrowHeightState={arrowHeightState} />
    ),
    nextArrow: (
      <NextArrow className="slick-next" arrowHeightState={arrowHeightState} />
    ),
    appendDots: (dots) => <ul style={{ top: dotsHeightState }}> {dots} </ul>,
    customPaging: (i) => <button>{i + 1}</button>,
  }

  return (
    <SbEditable content={block}>
      <section className="gallery-block">
        <div className="gallery-block-container">
          <div className="gallery-block-wrapper">
            <div className="gallery-block-content">
              <Slider {...settings}>
                {block.images?.length > 0 &&
                  block.images.map((item, index) => (
                    <div
                      className={`gallery-block-item skewed-${
                        index % 2 === 0 ? 'right' : 'left'
                      }`}
                      key={index}
                    >
                      <div className="gallery-block-item-image" ref={refChild}>
                        <Image
                          image={item.image}
                          alt={item.alt}
                          title={item.title}
                          forceLoad={index === 0 ? true : false}
                          imageWidth={1256}
                          imageHeight={705}
                        />
                      </div>
                      <div className="gallery-block-item-content">
                        <Headline headline_level="h4" headline={item.title} />
                        <Richtext text={item.text} />
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default GalleryBlock
